module.exports = __webpack_public_path__ + "static/media/upp_flo_loa_bay.4c57e764.png";